import { createSingletonMixin, compose, pathJoin } from '@descope/sdk-helpers';
import { loggerMixin } from '../loggerMixin/loggerMixin.js';
import { OVERRIDE_CONTENT_URL, BASE_CONTENT_URL, ASSETS_FOLDER } from './constants.js';
import { projectIdMixin } from '../projectIdMixin.js';
import { baseUrlMixin } from '../baseUrlMixin.js';

function getResourceUrl({ projectId, filename, assetsFolder = ASSETS_FOLDER, baseUrl, }) {
    const url = new URL(OVERRIDE_CONTENT_URL || baseUrl || BASE_CONTENT_URL);
    url.pathname = pathJoin(url.pathname, projectId, assetsFolder, filename);
    return url.toString();
}
const staticResourcesMixin = createSingletonMixin((superclass) => {
    const BaseClass = compose(loggerMixin, projectIdMixin, baseUrlMixin)(superclass);
    return class StaticResourcesMixinClass extends BaseClass {
        async fetchStaticResource(filename, format) {
            const resourceUrl = getResourceUrl({
                projectId: this.projectId,
                filename,
                baseUrl: this.baseStaticUrl,
            });
            const res = await fetch(resourceUrl, { cache: 'default' });
            if (!res.ok) {
                this.logger.error(`Error fetching URL ${resourceUrl} [${res.status}]`);
            }
            return {
                body: await res[format](),
                headers: Object.fromEntries(res.headers.entries()),
            };
        }
        get baseStaticUrl() {
            return this.getAttribute('base-static-url');
        }
    };
});

export { getResourceUrl, staticResourcesMixin };
//# sourceMappingURL=staticResourcesMixin.js.map
